import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TProductCart, TProductCartResponse, adaptProductCartFromResponse } from '../../types';
import { BACKEND_PRODUCT_CART } from '../../backend-paths';


export const productCartReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_PRODUCT_CART}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_PRODUCT_CART}/${payload}`;

		return HttpService.get<TProductCartResponse>(path).then(result => {
			return adaptProductCartFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProductCart> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const productCartReadSlice = createSlice({
	name: 'productCartReadSlice',
	initialState,
	reducers: {
		setProductCartRead(state, action: PayloadAction<TProductCart>) {
			state.item = action.payload;
		},

		clearProductCartRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[productCartReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[productCartReadGetApi.fulfilled.type]: (state, action: PayloadAction<TProductCart>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[productCartReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProductCartReadSelector = () => useAppSelector(state => state[productCartReadSlice.name]);

export const { clearProductCartRead, setProductCartRead } = productCartReadSlice.actions;
